import { render, staticRenderFns } from "./ProductMatrix.vue?vue&type=template&id=ff7aa4ae&scoped=true&"
import script from "./ProductMatrix.vue?vue&type=script&lang=js&"
export * from "./ProductMatrix.vue?vue&type=script&lang=js&"
import style0 from "./ProductMatrix.vue?vue&type=style&index=0&id=ff7aa4ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7aa4ae",
  null
  
)

export default component.exports